export default class EventBus {
  constructor() {
    this.listeners = new Map();
  }

  on(event, callback) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    this.listeners.get(event).add(callback);
    return () => this.off(event, callback);
  }

  once(event, callback) {
    const off = this.on(event, (...args) => {
      off();
      callback(...args);
    });
    return off;
  }

  off(event, callback) {
    if (!this.listeners.has(event)) return;
    const callbacks = this.listeners.get(event);
    callbacks.delete(callback);
    if (!callbacks.size) {
      this.listeners.delete(event);
    }
  }

  emit(event, ...args) {
    if (!this.listeners.has(event)) return;
    [...this.listeners.get(event)].forEach((callback) => {
      try {
        callback(...args);
      } catch (error) {
        console.error(`[EventBus] Error in listener for ${event}:`, error);
      }
    });
  }
}
